import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantsWithdraws = (id, page = 1) => useQuery({ queryKey: [`${id}-withdrawals`, page], queryFn: async () => {
    const callback = await API.get(`/consultants/${id}/withdraws?page=${page}`)
    return callback?.data
}})

export default useConsultantsWithdraws